// src/components/DialogButton.tsx
import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

interface DialogButtonProps {
  color?: 'primary' | 'secondary';
  onClick: () => void;
  variant?: 'text' | 'outlined' | 'contained'; 
  disabled?: boolean;
  children: React.ReactNode;
  text?: string;
}

const DialogButton = styled(Button)<DialogButtonProps>(({ theme, color }) => ({
  color: theme.palette.common.white,
  backgroundColor: color === 'primary' ? '#095d7e' : '#095d7e',
  borderColor: color === 'primary' ? '#4caf50' : '#f44336',
  height: '40px',
  padding: '8px 16px',
  borderRadius: '4px',
  fontFamily: 'Jost, sans-serif',
  '&:hover': {
    backgroundColor: color === 'primary' ? '#0870b4' : '#095d7e',
    borderColor: color === 'primary' ? '#0870b4' : '#c62828',
  },
  '&.Mui-disabled': {
    backgroundColor: '#d3d3d3', // Custom disabled background color
    color: '#a1a1a1', // Custom disabled text color
    borderColor: '#d3d3d3', // Custom disabled border color
    cursor: 'not-allowed', // Ensure cursor changes to not-allowed
    '&:hover': {
      backgroundColor: '#0084cf', // Ensure hover state is the same for disabled
      borderColor: '#d3d3d3',
    },
  },
  '&.MuiButton-containedPrimary': {
    background: 'linear-gradient(135deg, #0870b4, #0870b4)',
    border: '2px solid transparent',
    color: theme.palette.common.white,
    transition: 'background 0.3s ease, border-color 0.3s ease, transform 0.3s ease',
    transform: 'scale(1)',
    '&:hover': {
      background: 'linear-gradient(135deg, #0870b4, #0870b4)',
      
      transform: 'scale(1.05)',
    },
  },
  '&.MuiButton-containedSecondary': {
    backgroundColor: 'white',         // Background color remains white
    border: '2px solid #0870b4',     // Border color
    color: 'black',                   // Default text color
    transition: 'color 0.3s ease',   // Transition for color change only
    transform: 'scale(1)',
    '&:hover': {
        color: '#095d7e',             // Change text color on hover
        backgroundColor: 'white',     // Keep background color white on hover
        borderColor: '#0870b4',       // Change border color on hover if desired
        transform: 'scale(1.05)',      // Scale effect on hover
    },
},

}));

const CustomButton: React.FC<DialogButtonProps> = ({ color = 'primary', onClick, disabled, children }) => (
  <DialogButton
    color={color}
    onClick={onClick}
    disabled={disabled}
    variant="contained"
  >
    {children}
  </DialogButton>
);

export default CustomButton;
